import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralRankingByLang } from './partials/panelReferralRankingI18n';

function m(p) {
  return { ...en, ...p };
}

export default m({
  'common.theme': '主题',
  'common.themeLight': '浅色',
  'common.themeDark': '深色',
  'common.themeActive': '当前使用',
  'common.themeSwitchToDark': '切换到深色',
  'common.themeSwitchToLight': '切换到浅色',
  'common.settings': '设置',
  'common.loading': '加载中…',
  'settings.language': '语言',
  'settings.savePreferences': '保存偏好',
  'settings.savingPreferences': '保存中…',
  'auth.gate.userTitle': '正在验证会话',
  'auth.gate.userDescription': '正在确认登录，请稍候。',
  'auth.gate.agentTitle': '正在验证会话',
  'auth.gate.agentDescription': '正在确认代理登录，请稍候。',
  'user.layout.sidebarTitle': 'MineMe 用户面板',
  'user.layout.logout': '退出',
  'user.layout.nav.dashboard': '仪表盘',
  'user.layout.nav.deposit': '充值',
  'user.layout.nav.withdraw': '提现',
  'user.layout.nav.investments': '投资',
  'user.layout.nav.referral': '推荐',
  'user.layout.nav.notifications': '通知',
  'user.layout.nav.stopLoss': '止损',
  'user.layout.nav.transactions': '交易',
  'user.layout.nav.settings': '设置',
  'user.layout.balance.available': '可用余额',
  'user.layout.balance.frozen': '冻结余额',
  'user.layout.balance.interest': '利息余额',
  'user.layout.balance.bonus': '奖励余额',
  'user.dashboard.balance.available': '可用余额',
  'user.dashboard.balance.frozen': '冻结余额',
  'user.dashboard.balance.interest': '已获利息',
  'user.dashboard.balance.bonus': '奖励余额',

  'common.time.days': '天',
  'common.time.hours': '小时',
  'common.time.minutes': '分钟',
  'common.time.seconds': '秒',

  'user.dashboard.title': '仪表盘',
  'user.dashboard.loadingInvestments': '正在加载投资状态…',
  'user.dashboard.stats.totalInvested': '总投资',
  'user.dashboard.stats.netPnl': '净盈亏',
  'user.dashboard.stats.activePlans': '活跃方案',
  'user.dashboard.noInvestment.title': '暂无活跃投资',
  'user.dashboard.noInvestment.subtitle': '立即开始投资，以高收益让资产增值',
  'user.dashboard.noInvestment.cta': '查看投资方案',
  'user.dashboard.recentTx.title': '最近交易',
  'user.dashboard.recentTx.viewAll': '查看全部',
  'user.dashboard.recentTx.col.date': '日期',
  'user.dashboard.recentTx.col.type': '类型',
  'user.dashboard.recentTx.col.description': '说明',
  'user.dashboard.recentTx.col.amount': '金额',
  'user.dashboard.recentTx.col.status': '状态',
  'user.dashboard.recentTx.loading': '正在加载最近交易…',
  'user.dashboard.recentTx.empty': '暂无最近交易。',
  'user.dashboard.tx.Deposit': '充值',
  'user.dashboard.tx.Investment': '投资',
  'user.dashboard.tx.Referral': '推荐',
  'user.dashboard.tx.Bonus': '奖励',
  'user.dashboard.tx.Withdrawal': '提现',
  'user.dashboard.tx.E-Voucher': '电子券',
  'user.dashboard.tx.Stop-Loss': '止损',
  'user.dashboard.st.Completed': '已完成',
  'user.dashboard.st.Active': '进行中',
  'user.dashboard.st.Pending': '待处理',
  'user.dashboard.st.Failed': '失败',
  'user.dashboard.invest.planFallback': '方案',
  'user.dashboard.invest.activeBadge': '进行中',
  'user.dashboard.invest.detail.amountInvested': '投资金额',
  'user.dashboard.invest.detail.currentValue': '当前价值',
  'user.dashboard.invest.detail.pl': '盈亏',
  'user.dashboard.invest.detail.interestRate': '利率',
  'user.dashboard.invest.detail.perMonth': '每月 {{pct}}%',
  'user.dashboard.invest.detail.duration': '期限',
  'user.dashboard.invest.detail.months': '{{n}} 个月',
  'user.dashboard.invest.detail.startDate': '开始日期',
  'user.dashboard.invest.detail.nextWithdrawal': '下次提现',
  'user.dashboard.invest.countdownTitle': '距离下次提现',
  'user.dashboard.invest.progress': '进度',
  'user.dashboard.invest.progressPct': '已完成 {{pct}}%',
  'user.dashboard.invest.earlyWithdraw': '提前赎回',
  'user.dashboard.invest.planChip': '{{name}} 第 {{num}} 笔',
  'user.dashboard.invest.modal.title': '提前赎回提醒',
  'user.dashboard.invest.modal.investmentAmount': '投资金额：',
  'user.dashboard.invest.modal.platformFee': '平台手续费（{{pct}}%）：',
  'user.dashboard.invest.modal.interestForfeited': '放弃利息：',
  'user.dashboard.invest.modal.youWillReceive': '您将收到：',
  'user.dashboard.invest.modal.confirmHint': '请输入 CONFIRM 继续',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': '确认赎回',
  'user.dashboard.invest.modal.cancelling': '正在取消…',
  'user.dashboard.invest.toast.cancelled': '已取消投资',
  'user.dashboard.invest.toast.cancelFailed': '取消失败',

  'notifications.bell.triggerAria': '通知',
  'notifications.bell.title': '通知',
  'notifications.bell.loading': '加载中…',
  'notifications.bell.loadErrorSubtitle': '无法加载通知',
  'notifications.bell.unreadOne': '1 条未读更新',
  'notifications.bell.unreadMany': '{{count}} 条未读更新',
  'notifications.bell.allCaughtUp': '已全部阅读',
  'notifications.bell.markAllRead': '全部标为已读',
  'notifications.bell.empty': '暂无通知',
  'notifications.bell.emptyError': '无法加载通知',
  'notifications.bell.viewAll': '查看全部',
  'notifications.bell.markReadAria': '标为已读',
  'notifications.bell.time.justNow': '刚刚',
  'notifications.bell.time.secondsAgo': '{{n}} 秒前',
  'notifications.bell.time.minutesAgo': '{{n}} 分钟前',
  'notifications.bell.time.hoursAgo': '{{n}} 小时前',
  'notifications.bell.time.daysAgo': '{{n}} 天前',

  'agent.layout.logout': '退出',
  'agent.layout.nav.dashboard': '仪表盘',
  'auth.user.login.title': '用户登录',
  'auth.user.login.signIn': '登录',
  'auth.agent.login.title': '代理登录',
  'auth.agent.login.signIn': '登录',

  ...panelSettingsTransactionsByLang['zh-CN'],
  ...panelReferralRankingByLang['zh-CN'],
  ...panelUserExtraByLang['zh-CN'],
  ...panelDwiOverrides['zh-CN'],
  ...panelDepositBonusByLang['zh-CN'],
  ...panelVoucherStatusByLang['zh-CN'],
  ...panelWithdrawBep20ByLang['zh-CN'],
  ...panelDepositVoucherOverrides['zh-CN'],
  ...panelInvestmentsOverrides['zh-CN'],
  'user.investments.card.dailyProfit': '日收益',
  'user.investments.card.earningDays': '计息工作日',
  'user.investments.card.earningDaysValue': '{{count}} 个工作日',
  'user.investments.card.expectedProfit': '预期收益',
  'user.investments.card.investLimit': '投资限额',
  'user.investments.card.investLimitLine': '{{days}} 天内 {{count}} 次',
  'user.investments.card.investLimitReached': '您已达到该计划在当前周期内的投资限额。',
  'user.investments.card.limitReached': '已达限额',
  ...panelStopLossSlotsAssignOverrides['zh-CN'],
  ...panelStopLossFlowByLang['zh-CN'],
  ...panelUserSignupSocialForgotByLang['zh-CN'],
  ...panelAgentDashboardByLang['zh-CN'],
  ...panelAgentReferralsByLang['zh-CN'],
  ...panelAgentCommissionsByLang['zh-CN'],
  ...panelAgentWithdrawByLang['zh-CN'],
  ...panelAgentWithdrawUnlockStringsByLang['zh-CN'],
  'agent.withdraw.unlock.loadingTitle': '正在检查提现状态…',
  'agent.withdraw.unlock.loadingSubtitle': '正在加载您的推荐进度和解锁要求',
  'agent.withdraw.form.loadingTitle': '正在加载提现详情…',
  'agent.withdraw.form.loadingHint': '请稍候，正在加载余额和解锁状态',
  'agent.withdraw.unlock.requirementMet': '已满足要求',
  'agent.withdraw.unlock.minDepositHint':
    '仅统计推荐用户（不含下级代理）。每位用户须至少有 ${{amount}} 已完成入金。',
  ...panelAgentTransactionsByLang['zh-CN'],
  ...panelAgentLogsByLang['zh-CN'],
  ...panelAgentSettingsByLang['zh-CN'],
  ...panelAgentNotificationsByLang['zh-CN'],
  ...panelAgentTeamByLang['zh-CN'],
  ...panelAgentSignupByLang['zh-CN'],
  ...panelAgentLayoutByLang['zh-CN'],
  ...panelAgentAuthByLang['zh-CN'],
  ...panelUserPlatformTodayByLang['zh-CN'],
  ...panelStopLossHowLayoutByLang['zh-CN'],
  ...panelSupportTicketsByLang['zh-CN'],
});
